// API serialization uses snake_case; forms submit camelCase. Keep both read paths lossless.
export const normalizeOrderAddress = (address = {}) => Object.fromEntries(
  ['name', 'countryCode', 'country', 'postalCode', 'city', 'address', 'taxNumber', 'communityVatNumber', 'recipientName', 'deliveryPointExternalId']
    .map(field => [field, address[field] ?? address[field.replace(/[A-Z]/g, c => '_' + c.toLowerCase())] ?? ''])
);
